<template>
  <div class="content">
    <div class="tip" v-if="!adminShow">
      <p class="el-icon-info"><i>{{ $t('app.order.tip') }}</i></p>
    </div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          :placeholder="$t('app.order.companyName')"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable :placeholder="placeholderICCID" @keyup.enter.native="search" ></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" clearable :placeholder="placeholderOrderNum" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <template v-if="showSearch">
        <el-form-item  prop="productName" >
          <el-input v-model.trim="queryParams.productName" clearable :placeholder="$t('app.order.productName')" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item  prop="msisdn">
          <el-input v-model.trim="queryParams.msisdn" clearable :placeholder="placeholderMSISDN" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item  prop="startIccid" v-if="adminShow">
          <el-input v-model.trim="queryParams.startIccid" placeholder="开始号段"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="endIccid" v-if="adminShow">
          <el-input v-model.trim="queryParams.endIccid" placeholder="结束号段"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="phone" v-if="adminShow">
          <el-input v-model.trim="queryParams.phone" placeholder="手机号"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="email" v-if="adminShow">
          <el-input v-model.trim="queryParams.email" placeholder="邮箱" @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="orderStatus" >
          <el-select v-model="queryParams.orderStatus" filterable clearable multiple :placeholder="$t('app.order.orderStatus')" @change="search">
            <el-option v-for="item in optOrderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="orderType" v-if="adminShow">
          <el-select v-model="queryParams.orderType" filterable clearable multiple placeholder="订单类型" @change="search" >
            <el-option v-for="item in optOrderType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="payType" v-if="adminShow">
          <el-select v-model="queryParams.payType" filterable clearable multiple placeholder="支付方式" @change="search" >
            <el-option v-for="item in optpayType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> 
        </el-form-item>
        <el-form-item  prop="orderSource" >
          <el-select v-model="queryParams.orderSource" filterable clearable multiple :placeholder="$t('app.order.table.orderSource')" @change="search">
            <el-option v-for="item in optOrderSource" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>    
        </el-form-item>
        <el-form-item  prop="operatorId" >
          <el-select v-model="queryParams.operatorId" filterable clearable multiple :placeholder="$t('app.common.operator')" @change="search">
            <el-option v-for="item in optOperators" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>   
        </el-form-item>
        <el-form-item  prop="cardSourceId" v-if="adminShow">
          <el-select v-hasPermi="['card:cardSource']" v-model="queryParams.cardSourceId" filterable clearable multiple placeholder="卡源" @change="search" >
            <el-option v-for="item in optSource" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="mchId" v-if="adminShow">
          <el-select v-hasPermi="['order:list:mch']" v-model="queryParams.mchId" filterable placeholder="支付账号" @change="search" clearable >
            <el-option v-for="item in mchSources" :key="item.mchId" :label='item.mchId+"-"+item.name' :value="item.mchId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="currency" v-if="adminShow">
          <el-select v-model="queryParams.currency" filterable placeholder="币种" @change="search" clearable >
            <el-option v-for="item in currencyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="isExtraPrice" v-if="adminShow">
          <el-select v-model="queryParams.isExtraPrice" filterable placeholder="是否加价" @change="search" clearable >
            <el-option v-for="item in extraList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="dateRange" >
          <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('app.common.startDate')"
            :end-placeholder="$t('app.common.endDate')"
          ></el-date-picker>
        </el-form-item>
      </template>
      <el-form-item>
        <el-tooltip class="tooltip-button" :content="showSearch ? $t('app.common.hideSearch'):$t('app.common.showSearch')" placement="top">
          <el-button :icon="showSearch ? 'el-icon-arrow-up':'el-icon-arrow-down'" @click="showSearch=!showSearch"></el-button>
        </el-tooltip>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-hasPermi="['order:export']">{{ $t('app.common.export') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border  @selection-change="handleSelectionChange" tooltip-effect="dark" v-loading="loading">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row v-if="adminShow">
              <el-col :span="6">
                <el-form-item label="支付账号：" >
                  <span>{{ props.row.mchId }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付账号简称：" >
                  <span>{{ props.row.shortName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付账号名称：" >
                  <span>{{ props.row.mchName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="平台名称：" >
                  <span>{{ props.row.platform }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="MSISDN：" >
                  <span>{{ props.row.msisdn }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付时间：" >
                  <span>{{ props.row.paymentTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="母单号：" v-if="adminShow">
                  <span>{{ props.row.outOrderNum }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="签约订单号：" >
                  <span>{{ props.row.agreementNo }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="外部订单号：" >
                  <span>{{ props.row.transactionId }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="快递费：" >
                  <span>{{ props.row.expressFee }} {{ props.row.currency }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建人：" v-if="adminShow">
                  <span>{{ props.row.createUser }} </span>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="props.row.operationName == '国际'">
                <el-form-item label="卡种类：" v-if="adminShow">
                  <span>{{ props.row.cardType == 2 ? 'ESIM' : 'SIM' }} </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="adminShow">
              <el-col :span="6">
                <el-form-item label="支付渠道：" >
                  <span>{{ transferScene(props.row.scene) }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="index" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="orderNum" :label="$t('app.order.table.orderNum')" align="center" min-width="200px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-link v-if="scope.row.productType == 11 && checkPermi(['cardTrial:detail'])" type="primary" :underline="false" @click="infoRow(scope.row)">
            {{ scope.row.orderNum }}
          </el-link>
          <span v-else>{{ scope.row.orderNum }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="agentCompanyName" :label="$t('app.order.table.agent')" align="center" min-width="260px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" width="200px">
        <template slot-scope="scope">
            <el-link v-if="checkPermi(['order:detail'])" type="primary" :underline="false" @click="handleDetail(scope.row)">
              {{ scope.row.iccid }}
            </el-link>
            <span v-else>{{ scope.row.iccid }}</span>
            <el-tooltip class="item" v-if="!!scope.row.iccid" effect="dark" :content="$t('app.common.copy')" placement="top-start">
                <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="operationName" :label="$t('app.order.table.operator')" align="center"></el-table-column>
      <el-table-column prop="productName" :label="$t('app.order.table.productName')" align="center" width="158px" :show-overflow-tooltip="true"></el-table-column>

      <el-table-column prop="orderType" :label="$t('app.order.table.orderType')" align="center" v-if="adminShow"></el-table-column>
      <el-table-column prop="payType" :label="$t('app.order.table.payType')" align="center" min-width="100px"  v-if="adminShow"></el-table-column>
      <el-table-column prop="orderSource" :label="$t('app.order.table.orderSource')" align="center"></el-table-column>
      <el-table-column prop="accountMoney" :label="$t('app.order.table.price')" align="center"></el-table-column>
      <el-table-column prop="orderStatus" :label="$t('app.order.table.status')" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.orderStatus == '3'">{{transferOrderStatus(row.orderStatus)}}</el-tag>
          <el-tag v-if="row.orderStatus =='1'" type="danger">{{transferOrderStatus(row.orderStatus)}}</el-tag>
          <el-tag v-if="row.orderStatus =='4'" type="warning">{{transferOrderStatus(row.orderStatus)}}</el-tag>
          <div v-if="row.orderStatus =='6' && row.status =='1'" >
            <el-tag v-if="row.originalStatus == '3'">{{transferOrderStatus(row.originalStatus)}}</el-tag>
            <el-tag v-else-if="row.originalStatus == '1'" type="danger">{{transferOrderStatus(row.originalStatus)}}</el-tag>
            <el-tag v-else type="warning">{{transferOrderStatus(row.originalStatus)}}</el-tag>
            <el-tag type="warning">{{transferOrderStatus(row.orderStatus)}}</el-tag>
          </div>
          <div v-if="row.status =='0'" >
            <el-tag type="warning">已清除</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('app.common.createTime')" align="center" min-width="160px"></el-table-column>
      
      <el-table-column prop="currency" :label="$t('app.order.table.currency')" align="center"></el-table-column>
      <el-table-column prop="phone" :label="$t('app.order.table.phone')" align="center" v-if="adminShow" width="110px"></el-table-column>
      <el-table-column prop="email" :label="$t('app.order.table.email')" align="center" :show-overflow-tooltip="true" v-if="adminShow" width="120px"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
  </div>
</template>
<script>
import { orderList} from "@/api/api.js"; //订单列表
import { agentTreeList } from "@/api/api.js"; //代理商
import { cardSource } from "@/api/api.js"; //卡源
import { exportOrder } from "@/api/api.js"; //订单列表导出
import { payConfigSource } from "@/api/api.js"; //收款账号
export default {
  
  name: "orderlist",
  data() {
    return {
      // 显示搜索条件
      showSearch: false,
      loading:false,
      placeholderICCID:"ICCID",
      placeholderOrderNum:"订单号",
      placeholderMSISDN:"MSISDN",
      agentTree: [],
      optSource: [],
      currencyList:[
        // 人民币 美元 欧元 英镑 日元 泰铢
        { value: "RMB", label: "人民币 - RMB"},
        { value: "USD", label: "美元 - USD"},
        { value: "EUR", label: "欧元 - EUR"},
        { value: "GBP", label: "英镑 - GBP"},
        { value: "JPY", label: "日元 - JPY"},
        { value: "THB", label: "泰铢 - THB"},
      ],
      gprsStatus:[
        { value: 0, label: "比例模式"},
        { value: 1, label: "底价模式"},
      ],
      optOperators: [
        { value: 1, label: this.$t('app.common.chinaTelecom') },
        { value: 2, label: this.$t('app.common.chinaMobile') },
        { value: 3, label: this.$t('app.common.chinaUnicom') },
        { value: 4, label: this.$t('app.common.international') }
      ],
      optOrderStatus: [
        { value: 1, label: "未支付" },
        { value: 2, label: "已支付" },
        { value: 3, label: "已到账" },
        { value: 4, label: "已退款" },
        { value: 7, label: "退款中" },
        { value: 8, label: "退款失败" },
        { value: 6, label: "已清除" }
      ],
      // 订单类型
      optOrderType: [
        { value: 1, label: "API" },
        { value: 2, label: "用户" },
        { value: 3, label: "赠送" },
        { value: 4, label: "其他" },
        { value: 5, label: "批量充值"},
        { value: 6, label: "用户批量充值"},
        { value: 7, label: "积分兑换"},
      ],
      // 支付方式
      optpayType: [
        { value: 2, label: "微信支付" },
        { value: 3, label: "余额支付" },
        { value: 7, label: "佣金支付" },
        { value: 4, label: "系统支付" },
        { value: 1, label: "微信H5支付" },
        { value: 5, label: "支付宝H5支付" },
        { value: 6, label: "贝宝支付" },
        { value: 8, label: "小程序支付" },
        { value: 9, label: "云闪付支付" },
        { value: 10, label: "Stripe支付" }
      ],
      // 订单来源
      optOrderSource:[
        { value: 1, label: this.$t('app.order.source.user') },
        { value: 2, label: this.$t('app.order.source.system') },
        { value: 3, label: this.$t('app.order.source.agent') },
        { value: 4, label: this.$t('app.order.source.international') }
      ],
      mchSources:[],
      extraList:[
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      tableData: [],
      queryParams: {
        userId:undefined,
        iccid:undefined,
        orderNum:undefined,
        productName:undefined,
        msisdn:undefined,
        startIccid:undefined,
        endIccid:undefined,
        phone:undefined,
        orderStatus:undefined,
        orderType:undefined,
        payType:undefined,
        orderSource:undefined,
        operatorId:undefined,
        cardSourceId:undefined,
        mchId:undefined,
        currency:undefined,
        isExtraPrice:undefined,
        email:undefined
      },
      dateRange: [],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
    };
  },
  computed: {
    adminShow (){
        return this.$store.getters.user.userType =='1';
    }
  },
  methods: {
    handleSelectionChange(val){
      let arr = [];
      val.map(item => {
        arr.push(item.iccid)
      });
    },
    // 订单类型
    transferOrderType(status) {
      let obj = {
        1: "API",
        2: "用户",
        3: "赠送",
        4: "其他",
        5: "批量充值",
        6: "用户批量充值",
        7: "积分兑换"
      };
      return obj[status];
    },
    transferScene(scene) {
      if(!scene){
        return ""
      }
      let obj = {
        "h5": "H5",
        "web": "网页",
        "website": "国际站",
        "wechat": "公众号",
        "wcMini": "智汇桔小程序",
        "intMini": "国际环球流量小程序",
      };
      return obj[scene];
    },
    // 支付方式
    transferPayType(status){
      let obj = {
        1: "微信H5支付",
        2: "微信支付",
        3: "余额支付",
        4: "系统支付",
        5: "支付宝H5支付",
        6: "贝宝支付",
        7: "佣金支付",
        8: "小程序支付",
        9: "云闪付支付",
        10: "Stripe支付"
      };
      return obj[status];
    },
    // 订单来源
    transferOrderSource(status){
      let obj = {
        1: this.$t('app.order.source.user'),
        2: this.$t('app.order.source.system'),
        3: this.$t('app.order.source.agent'),
        4: this.$t('app.order.source.international')
      };
      return obj[status];
    },
    transferOrderStatus(status) {
      let obj = {
        1: this.$t('app.order.status.unpaid'),
        2: this.$t('app.order.status.paid'),
        3: this.$t('app.order.status.received'),
        4: this.$t('app.order.status.refunded'),
        6: this.$t('app.order.status.cleared')
      };
      return obj[status];
    },
    // 获取列表
    queryInfo() {
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      orderList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.tableData.map((item,index) => {
          // item.orderStatus = this.transferOrderStatus(item.orderStatus);
          item.orderType = this.transferOrderType(item.orderType);
          item.payType = this.transferPayType(item.payType);
          item.orderSource = this.transferOrderSource(item.orderSource)
        })
        this.loading = false;
      });
    },

    //代理商下拉列表
    handleAgentTreeList() {
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 获取卡来源下拉
    querySource() {
      cardSource().then(res => {
        this.optSource = res.data.data;
      });
    },
    //获取所有支付商号
    mchSource(){
      payConfigSource({}).then(res=>{
        this.mchSources = res.data.data;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.queryInfo();
    },
    // 详情-跳转到申请卡详情
    infoRow(row){
      this.$router.push(`/device/cardTrialDetail/`+row.orderNum);
    },
    // 详情
    handleDetail(row) {
      if(row.operationName == '国际'){
        this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
      }else{
        this.$router.push({path:"/card/detail",query:{iccid: row.iccid}});
      }
      
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: this.$t('app.common.copySuccess'),
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.dateRange = [];
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.search();
    },
    // 导出
    handleExport() {
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
      };
      this.$alert(this.$t('app.order.export.confirm'), this.$t('app.order.export.title'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        exportOrder(params).then(res => {
          this.$notify({
              title: this.$t('app.common.success'),
              message: this.$t('app.order.export.success'),
              type: "success",
              offset:30
            });
        });
      }).catch(() => {});
    },
    
  },
  created() {
    if(this.adminShow){
      this.placeholderICCID=this.$t('app.order.placeholder.iccidAdmin');
      this.placeholderOrderNum=this.$t('app.order.placeholder.orderNumAdmin');
      this.placeholderMSISDN="MSISDN/MSISDNS";


    }else{
      this.placeholderICCID="ICCID";
      this.placeholderOrderNum=this.$t('app.order.placeholder.orderNum');
      this.placeholderMSISDN="MSISDN";
      this.optOrderSource = [
        { value: 1, label: this.$t('app.order.source.user')},
        { value: 3, label: this.$t('app.order.source.agent')},
      ]
      this.optOrderStatus = [
        { value: 3, label:this.$t('app.order.status.received')},
        { value: 4, label: this.$t('app.order.status.refunded')},
      ]

    }
  },
  mounted() {
    this.queryInfo();
    this.handleAgentTreeList();
    if(this.checkPermi(['card:cardSource'])){
      this.querySource();
    }
    if(this.checkPermi(['order:list:mch'])){
      this.mchSource();
    }
    
  }
};
</script>
<style scoped lang="less">
.table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }
.tooltip-button{
  padding:10px 10px ;
}
.content{
  .tip{
    padding: 0px 7px;
    background-color: #ecf8ff;
    border-radius: 4px;
    border-left: 5px solid #50bfff;
    margin: 8px 0;
    margin-top: -12px;
    p{
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.5em;
      i{
          font-style: italic;
      }
    }

  }
  
}
</style>
